import React, { FC } from "react";
import { isNotNil } from "ramda-adjunct";
import { useNativeFulfilmentChipTemplate } from "@sinch/components/AttendanceCounter/useNativeFulfilmentChipTemplate";
import { AttendanceStatusEnum as AttendanceStatus } from "@sinch/core/entities/serverEnums.types";
import { AttendanceStatusEnum } from "@sinch/core/entities/serverEnums";

export interface AttendanceCounterProps {
  /**
   * attending attendance count
   */
  attendance: number;
  /**
   * total attendance count
   */
  attendanceSlots: number;
  /**
   * attending standby count
   */
  standby?: number | null;
  /**
   * total standby count
   */
  standbySlots?: number | null;
  /**
   * pending confirmation attendance count
   */
  attendancePending?: number | null;
}

/**
 * AttendanceCounter displays the state of the attendance in the day column header.
 * Attendance can have up to 3 segments for attendees, invited staff and standbys.
 * Each segment is colored based on if there are empty slots or not
 */
export const AttendanceCounter: FC<AttendanceCounterProps> = ({
  attendance,
  attendanceSlots,
  standby,
  standbySlots,
  attendancePending,
}) => {
  const { fillData, template } = useNativeFulfilmentChipTemplate();

  return (
    <div
      ref={(el) => {
        if (isNotNil(el)) {
          el.replaceChildren();
          const templateEl = document.createElement("template");
          templateEl.innerHTML = template.trim();
          const box = templateEl.content.firstElementChild;
          fillData<HTMLDivElement>(box as HTMLDivElement, {
            attendance,
            attendanceSlots,
            standby: standby ?? undefined,
            standbySlots: standbySlots ?? undefined,
            attendancePending: attendancePending ?? undefined,
          });
          el.appendChild(box!);
        }
      }}
    ></div>
  );
};

export const attendanceCount = (attendances: { status?: AttendanceStatus | null }[]): number =>
  attendances.filter((att) => (isNotNil(att?.status) ? att?.status !== AttendanceStatusEnum.ConfirmationPending : true))
    .length;

export const pendingCount = (attendances: { status?: AttendanceStatus | null }[]): number =>
  attendances.filter((att) => (isNotNil(att?.status) ? att?.status === AttendanceStatusEnum.ConfirmationPending : true))
    .length;


